import store from "@/store";
import DepService from "@/services/depService";

export async function userAuthenticate(to, from, next) {
    return await userAuthMsisdn(to, from, next);
}

async function userAuthMsisdn(to, from, next) {
    if (store.state.user) return next();
    const urlParams = new URLSearchParams(window.location.search);
    const encryptedMsisdn = urlParams.get('e-msisdn');
    if (encryptedMsisdn) return await encryptedMsisdnAuth(encryptedMsisdn, next);
}

async function encryptedMsisdnAuth(encryptedMsisdn, next) {
    const {rawMsisdn} = (await DepService.decryptMsisdn(encryptedMsisdn)).data;
    const userData = (await DepService.getUserViaProductId(rawMsisdn)).data.user;
    store.commit('setUser', userData);
    next('/landing');
}